export default __webpack_public_path__ + "static/media/theano.cdc6e491.jpg";